import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m2.5 15.5 2.094.418a1 1 0 0 1 .636.426l1.522 2.284a1 1 0 0 0 .69.435l2.833.404a1 1 0 0 1 .414.158L13.5 21.5m8-13-2.094-.419a1 1 0 0 1-.636-.426l-1.522-2.283a1 1 0 0 0-.69-.435l-2.833-.405a1 1 0 0 1-.414-.158L10.5 2.5m11 18.998v-19h-19v19h19Zm-12-9.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.5 2.5 10 10m11.5 11.5L14 14",
  "stroke-dasharray": "1.8 1.2"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }